import EquipmentType from './EquipmentType'
import Section from './Section'
import BaseEntity from '../baseclasses/BaseEntity'
export class ModelGroup extends BaseEntity{
    ID?: number;
    SectionID?: number;
    Section?: Section;
    EquipmentTypeID?: number;
    EquipmentType?: EquipmentType;
    Name?: string;
    Inactive: boolean;
    NonSerialized?: boolean;

}

export default ModelGroup;